import { useTranslation } from "react-i18next";

interface NjbsoftMarkProps {
  /** Sizes the mark; it draws at 40px without one. */
  className?: string;
}

/**
 * NJBSoft's own mark, for the pages that belong to no utility: an ink tile
 * with the N cut out in the surface color, so it inverts with the theme.
 */
export function NjbsoftMark({ className = "size-10" }: NjbsoftMarkProps) {
  const { t } = useTranslation("customer");
  return (
    <svg
      viewBox="0 0 40 40"
      role="img"
      aria-label={t("shell.njbsoftMark")}
      className={`shrink-0 text-ink ${className}`}
    >
      <rect width="40" height="40" rx="10" fill="currentColor" />
      <path
        className="text-surface"
        fill="currentColor"
        d="M12.5 28V12h3.4l8.3 10.9V12h3.3v16h-3.4l-8.3-10.9V28z"
      />
    </svg>
  );
}
